import script from "./SiteHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./SiteHeader.vue?vue&type=script&setup=true&lang=ts"

import "./SiteHeader.vue?vue&type=style&index=0&id=1f8ee776&scoped=true&lang=scss"

import exportComponent from "D:\\frontend\\finans\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f8ee776"]])

export default __exports__